const topicTags = [
  { id: 1, name: '明星翻车', heat: 98, trend: 'up' },
  { id: 2, name: '网红带货', heat: 95, trend: 'up' },
  { id: 3, name: '综艺剧本', heat: 91, trend: 'up' },
  { id: 4, name: '品牌塌房', heat: 88, trend: 'up' },
  { id: 5, name: '恋情曝光', heat: 85, trend: 'stable' },
  { id: 6, name: '直播内幕', heat: 82, trend: 'up' },
  { id: 7, name: '选秀黑幕', heat: 79, trend: 'down' },
  { id: 8, name: '税务风波', heat: 76, trend: 'up' },
  { id: 9, name: '代言解约', heat: 72, trend: 'stable' },
  { id: 10, name: '素人爆料', heat: 68, trend: 'up' },
];

export default function SectionTopics() {
  return (
    <section id="topics" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-6 md:px-10">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-4 whitespace-nowrap">
              <i className="ri-hashtag"></i> 热度飙升
            </span>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-3">
              话题热度榜
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto leading-relaxed">
              实时追踪全网最热话题标签，热门爆料话题热度一目了然
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {topicTags.map((tag) => (
              <div
                key={tag.id}
                className="group bg-background-50 rounded-full px-5 py-3 flex items-center gap-3 hover:bg-primary-50 transition-colors cursor-pointer"
              >
                <span className="text-xs font-bold text-foreground-500 w-5 text-center">
                  {tag.id}
                </span>
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  #{tag.name}
                </span>
                <div className="flex items-center gap-1.5">
                  {tag.trend === 'up' ? (
                    <i className="ri-arrow-up-line text-xs text-primary-500"></i>
                  ) : tag.trend === 'down' ? (
                    <i className="ri-arrow-down-line text-xs text-secondary-500"></i>
                  ) : (
                    <i className="ri-subtract-line text-xs text-foreground-400"></i>
                  )}
                  <span className={`text-xs font-semibold ${
                    tag.trend === 'up' ? 'text-primary-600' :
                    tag.trend === 'down' ? 'text-secondary-600' :
                    'text-foreground-500'
                  }`}>
                    {tag.heat}°
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}